import {
    LayoutDashboard,
    // FileCode2, // Removed API Docs icon
    Settings,
    Home,
    // LogIn, // Removed unused import
    // UserPlus, // Removed unused import
    LucideIcon, // Import LucideIcon type for icon property
    ScanLine,
    Archive, // Added Archive icon for Brands
} from 'lucide-react';

export type NavItemVisibility =
    | 'always'
    | 'loggedIn'
    | 'loggedOut'
    | 'anonOnly';

export interface NavItemConfig {
    href: string; // Language-agnostic path (will be prefixed with /lang)
    labelKey: string; // Key for translation lookup (e.g., from en.json)
    icon: LucideIcon; // Lucide icon component
    visibility: NavItemVisibility; // Controls when the link is shown
    isExternal?: boolean; // Optional: Flag for external links
}

export const navigationConfig: NavItemConfig[] = [
    // --- Always Visible ---
    {
        href: '/',
        labelKey: 'navbar.home', // Assumes a 'Home' translation exists
        icon: Home,
        visibility: 'always',
    },
    {
        href: '/brands', // Path to the existing brands page
        labelKey: 'navbar.brands', // New translation key for "Brands"
        icon: Archive, // Using Archive icon for "Brands"
        visibility: 'always', // Show to all users
    },
    {
        href: '/feed',
        labelKey: 'navbar.feed',
        icon: LayoutDashboard,
        visibility: 'loggedIn',
    },
    {
        href: '/scanner',
        labelKey: 'navbar.scanner',
        icon: ScanLine,
        visibility: 'loggedIn',
    },
    // --- Logged In Only ---
    {
        href: '/settings/account',
        labelKey: 'navbar.settings', // Assumes 'API Settings' translation
        icon: Settings,
        visibility: 'loggedIn',
    },
    // --- Logged Out Only ---
    // {
    //     href: '/login',
    //     labelKey: 'navbar.login', // Assumes 'Login' translation
    //     icon: LogIn,
    //     visibility: 'loggedOut',
    // },
    // {
    //     href: '/signup',
    //     labelKey: 'navbar.signup', // Assumes 'Sign Up' translation
    //     icon: UserPlus,
    //     visibility: 'loggedOut',
    // },
    // --- Anonymous Only (Example - if needed) ---
    // {
    //   href: '/some-anon-feature',
    //   labelKey: 'navbar.anonFeature',
    //   icon: HelpCircle,
    //   visibility: 'anonOnly',
    // },
];
